import { useRef, useState } from "react";
import styles from "./sign_up_login/login.module.css";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { authenticatedFetch } from "../services/apiClient";

export default function DeleteAccount() {
  const navigate = useNavigate();
  const prevPasswordRef = useRef();
  const [isDeleting, setIsDeleting] = useState(false);

  let BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const deleteAccount = async (e) => {
    e.preventDefault();

    const password = prevPasswordRef.current.value;

    if (!password) return alert("Please enter password");

    setIsDeleting(true);

    try {
      const user = auth.currentUser;
      if (!user) {
        navigate("/login");
        return;
      }

      const verifyRes = await authenticatedFetch(`${BACKEND_URL}/api/auth/verify-password`, {
        method: "POST",
        body: JSON.stringify({ uid: user.uid, password }),
      });

      const verifyJson = await verifyRes.json();
      if (!verifyJson.success) {
        setIsDeleting(false);
        return alert("Password is incorrect!");
      }

      const res = await authenticatedFetch(`${BACKEND_URL}/api/auth/delete-account`, {
        method: "POST",
        body: JSON.stringify({ uid: user.uid }),
      });

      const json = await res.json();

      if (json.success) {
        // Sign out from Firebase
        await auth.signOut();
        navigate("/login");
      } else {
        alert("Failed to delete account");
      }
    } catch (err) {
      console.error("Delete account error:", err);
      alert("Something went wrong");
    }

    setIsDeleting(false);
  };

  return (
    <div className={styles["login-form--container"]}>
      <form onSubmit={deleteAccount} className={styles["login-form"]}>
        <input
          type="password"
          required
          ref={prevPasswordRef}
          placeholder="Enter password for confirmation"
        />
        <button disabled={isDeleting} className="sign-out">
          {isDeleting ? "Deleting..." : "Delete Account"}
        </button>
      </form>
    </div>
  );
}
